'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBoxShadow = function getBoxShadow(boxShadow, radius, color) {
  if (typeof boxShadow === 'string') return boxShadow;
  return boxShadow === true ? '0 0 ' + radius + 'px ' + color : undefined;
};

exports.default = _react2.default.createClass({
  displayName: 'UINanoProgress',

  propTypes: {
    boxShadow: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
    className: _react.PropTypes.string,
    color: _react.PropTypes.string,
    height: _react.PropTypes.number,
    value: _react.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      boxShadow: true,
      color: _colors.SORBET,
      height: 2,
      value: 0
    };
  },
  render: function render() {
    var _props = this.props,
        boxShadow = _props.boxShadow,
        className = _props.className,
        color = _props.color,
        height = _props.height,
        value = _props.value;

    return value >= 0 && _react2.default.createElement(
      'div',
      { className: (0, _classNames2.default)('private-nano-progress', className) },
      _react2.default.createElement('div', {
        'aria-valuemax': 100,
        'aria-valuemin': 0,
        'aria-valuenow': value,
        className: 'private-nano-progress__bar',
        role: 'progressbar',
        style: {
          width: value + '%',
          background: color,
          boxShadow: getBoxShadow(boxShadow, height * 3, color),
          height: height,
          transition: 'all 200ms ease'
        }
      })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/progress/UINanoProgress.js
// module id = 1159
// module chunks = 2 3